document.addEventListener('DOMContentLoaded', () => {
    const backToCollectionButton = document.getElementById('back-to-collection');

    if (backToCollectionButton) {
        backToCollectionButton.addEventListener('click', () => {
            const collectionPage = sessionStorage.getItem('collectionPage') || sessionStorage.getItem('openSaleCollectionPage');

            if (collectionPage) {
                window.location.href = collectionPage;
            } 
            else {
                window.history.back();
            }
        });
    }
});
